import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../utils/formatDate';

interface CancelSubscriptionDialogProps {
  open: boolean;
  packageName?: string;
  freePackageName: string;
  endAt?: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const CancelSubscriptionDialog: React.FC<CancelSubscriptionDialogProps> = ({
  open,
  packageName,
  freePackageName,
  endAt,
  onClose,
  onConfirm,
}) => {
  const { t, i18n } = useTranslation();
  const formattedEndAt = endAt ? formatDate(endAt, i18n.language) : '';
  const currentPackageName = packageName ?? t('subscription.plan.currentGeneric');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('subscription.cancelDialog.title', 'Cancel Subscription')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('subscription.cancelDialog.description', {
            defaultValue:
              'Your {{packageName}} plan stays active until {{endAt}}. After that you will switch to FREE. Unused monthly allowance does not carry over; your advance balance is kept.',
            packageName: currentPackageName,
            freePackageName,
            endAt: formattedEndAt,
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {t('subscription.cancelDialog.keep', 'Keep Subscription')}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t('subscription.cancelDialog.confirm', 'Cancel Subscription')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
